import { StatisticsByCustomerThreeYearsStatisticsDetailsQuery } from "@/gql/graphql";
import _ from "lodash";
import { ThreeYearsTargetActualTableRow } from "../../config/ThreeYearsTargetActualTableConfig";
import { ThreeYearsPricePerMeterTableRow } from "../../config/ThreeYearsPricePerMeterTableConfig";
import { ThreeYearsVolumeExpectedTableRow } from "../../config/ThreeYearsVolumeExpectedTableConfig";

export const transformThreeYearsTargetAndActualToTableRows = (
  threeYearsTargetAndActual: StatisticsByCustomerThreeYearsStatisticsDetailsQuery["statistics"]["customerDetails"]["threeYearsTargetAndActualByCustNoAndYear"],
  year: number
): ThreeYearsTargetActualTableRow[] => {
  const groupedData = _.groupBy(threeYearsTargetAndActual, "routePairCode");

  return Object.entries(groupedData).map(([routePairCode, group]) => {
    const yearDataMap = _.keyBy(group, "year");

    const dataThisYear = yearDataMap[year];
    const dataMinus1Years = yearDataMap[year - 1];
    const dataMinus2Years = yearDataMap[year - 2];

    return {
      routePairCode,
      year,
      target: dataThisYear?.targetInPercent,
      actual: dataThisYear?.actualOutcomeInPercent,
      targetMinus1Year: dataMinus1Years?.targetInPercent,
      actualMinus1Year: dataMinus1Years?.actualOutcomeInPercent,
      targetMinus2Year: dataMinus2Years?.targetInPercent,
      actualMinus2Year: dataMinus2Years?.actualOutcomeInPercent,
    };
  });
};

export const transformThreeYearsPricePerMeterToTableRows = (
  threeYearsPricePerMeter: StatisticsByCustomerThreeYearsStatisticsDetailsQuery["statistics"]["customerDetails"]["threeYearsPricePerMeterByCustNoYearAndCurrency"],
  year: number
): ThreeYearsPricePerMeterTableRow[] => {
  const groupedData = _.groupBy(threeYearsPricePerMeter, "routePairCode");
  return Object.entries(groupedData).map(([routePairCode, group]) => {
    const yearDataMap = _.keyBy(group, "year");

    const dataThisYear = yearDataMap[year];
    const dataMinus1Years = yearDataMap[year - 1];
    const dataMinus2Years = yearDataMap[year - 2];

    return {
      routePairCode,
      year,
      pricePerMeter: dataThisYear?.pricePerMeter,
      pricePerMeterMinus1Year: dataMinus1Years?.pricePerMeter,
      pricePerMeterMinus2Year: dataMinus2Years?.pricePerMeter,
    };
  });
};

export const transformThreeYearsVolumeExpectedToTableRows = (
  threeYearsVolumeExpected: StatisticsByCustomerThreeYearsStatisticsDetailsQuery["statistics"]["customerDetails"]["threeYearsVolumeAndExpectedByCustNoAndYear"],
  year: number
): ThreeYearsVolumeExpectedTableRow[] => {
  const groupedData = _.groupBy(threeYearsVolumeExpected, "routePairCode");
  return Object.entries(groupedData).map(([routePairCode, group]) => {
    const yearDataMap = _.keyBy(group, "year");

    const dataThisYear = yearDataMap[year];
    const dataMinus1Years = yearDataMap[year - 1];
    const dataMinus2Years = yearDataMap[year - 2];

    return {
      routePairCode,
      year,
      expected: dataThisYear?.expectedVolume,
      volume: dataThisYear?.volume,
      expectedMinus1Year: dataMinus1Years?.expectedVolume,
      volumeMinus1Year: dataMinus1Years?.volume,
      expectedMinus2Year: dataMinus2Years?.expectedVolume,
      volumeMinus2Year: dataMinus2Years?.volume,
    };
  });
};
